import angular from 'angular';

angular.module('folkeuni').factory('ContractApi', function($http, $q) {
  var self = this;
  var apiBase = '/api/contract/';

  self.approve = function(contractObj) {
    return $http({
      data: contractObj,
      method: 'post',
      url: apiBase + 'accept'
    });
  }

  self.attachmentCreate = function(attachmentObj, file) {
    var fd = new FormData();
    fd.append('data', angular.toJson(attachmentObj));
    fd.append('file', file);

    var deferred = $q.defer();
    $http({
      headers: {
        'Content-Type': undefined
      },
      uploadEventHandlers: {
        progress: function(e) {
          //$log.info('progress ', e);
          // console.log(e);
          deferred.notify(e.loaded * 100 / e.total);
        }
      },
      method: 'post',
      data: fd,
      url: apiBase + 'attachment'
    }).then(function(response) {
        deferred.resolve(response.data);
      },
      function(response) {
        deferred.reject(response);
      }
    )

    return deferred.promise;

  }

  self.attachmentDelete = function(attachmentObj) {
    return $http({
      data: attachmentObj,
      headers:{
        "Content-Type": "application/json"
      },
      method: 'delete',
      url: apiBase + 'attachment'
    });
  }

  self.getAll = function(orderBy) {
    return $http({
      method: 'get',
      url: orderBy ? apiBase + '/' + orderBy : apiBase
    });
  }

  self.reject = function(contractObj) {
    return $http({
      data: contractObj,
      method: 'post',
      url: apiBase + "decline"
    });
  }



  return self;
});
